import { useState, useEffect } from 'react'
import { Text } from '@chakra-ui/react'

// Easy-to-edit styles
const styles = {
    heroSection: {
        minHeight: '95vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 1.5rem',
        paddingTop: '5rem'
    },

    container: {
        maxWidth: '80rem', // 7xl equivalent
        width: '100%',
        display: 'grid',
        gap: '3rem',
        alignItems: 'center',
        marginTop: '-1.5rem',
    },

    textSection: {
        textAlign: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },

    mainHeading: {
        fontSize: '4rem', // 5xl
        fontWeight: '800',
        lineHeight: '1.1',
        marginBottom: '1.5rem',
        minHeight: '4rem', // Prevent layout shift during typing
    },

    description: {
        fontSize: '1.25rem',
        marginBottom: '2rem',
        color: 'var(--text-dim)',
        width: '70%',
    },

    visualizerContainer: {
        display: 'flex',
        justifyContent: 'center'
    }
}

// Typing animation component
export default function TypingAnimation({phrases}) {
    const [displayText, setDisplayText] = useState('')
    const [isDeleting, setIsDeleting] = useState(false)
    const [phraseIndex, setPhraseIndex] = useState(0)
    const [showCursor, setShowCursor] = useState(true)

    const basePhrase = ""

    useEffect(() => {
        const currentPhrase = phrases[phraseIndex]

        const timer = setTimeout(() => {
            if (!isDeleting) {
                // Typing forward
                if (displayText.length < currentPhrase.length) {
                    setDisplayText(currentPhrase.slice(0, displayText.length + 1))
                } else {
                    // Finished typing, wait then start deleting
                    setTimeout(() => setIsDeleting(true), 600)
                }
            } else {
                // Deleting/backspacing
                if (displayText.length > basePhrase.length) {
                    setDisplayText(displayText.slice(0, -1))
                } else {
                    // Finished deleting to base phrase, switch to next phrase
                    setIsDeleting(false)
                    setPhraseIndex((prev) => (prev + 1) % phrases.length)
                }
            }
        }, getTypingSpeed())

        return () => clearTimeout(timer)
    }, [displayText, isDeleting, phraseIndex])

    // Cursor blinking effect
    useEffect(() => {
        const cursorTimer = setInterval(() => {
            setShowCursor(prev => !prev)
        }, 530)
        return () => clearInterval(cursorTimer)
    }, [])

    // Realistic typing speeds with variation
    function getTypingSpeed() {
        if (isDeleting) {
            return Math.random() * 12 + 8;   // 8–20 ms  (much faster)
        } else {
            return Math.random() * 25 + 15;  // 15–40 ms (faster)
        }
    }

    return (
        <Text
            fontSize={"lg"} // Customizable font size
            bgGradient="linear(to-r, #2563eb, #7c3aed)" // Gradient text styling
            bgClip="text"
            fontWeight="semibold"
            whiteSpace="nowrap" // Prevents text wrapping
        >
            {displayText}
            <Text
                as="span"
                style={{
                    opacity: showCursor ? 1 : 0,
                    transition: 'opacity 0.1s',
                    marginRight: '-0.2rem'
                }}
            >
                |
            </Text>
        </Text>
    )
}
